import { composeSx as sharedComposeSx } from '@hrlogics/react-helper-utils';

export const composeSx = sharedComposeSx;
